const Howcanispeak =() =>{
    return(
        <>
         <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">How can i peak</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    How can i peak
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">How Can i Speak</h1>
            </div>
            
            <div className="wow fadeInUp" data-wow-delay="0.2s">
    <div className="row">
        <div className="col-lg-12 wow fadeInUp" data-wow-delay="0.5s">
            <div className="card why-choose-card border-0 shadow h-100 p-4">

                <p className="mb-3">
How Can I Speak English ? this is the very first question which comes in your mind when you start thinking about learning English , because simply we are learning English to learn how to speak , how to communicate with people , how to express about our self , how to explain or present a topic , and many , so this is the very important major part of language , and that is called as communication skills which makes you able to be good English speaker .
                </p>

                <p className="mb-4">
Then what is the answer of this question ? simply “ how to study english “ is the right answer for your question , because the way that you are following to study English language is very important , if you are only studying theory with out any practical then the result is zero even if you get high marks in theory exams , so you have to follow the proper way of language learning and the only proper way of English learning is simply talking and speaking continuesly and that is absolutely along with the theory class because the theory classes will give you the basics of language then based on that you have to practice a lot and Learn how to speak English.
                </p>
                <div className="row align-items-center">
  
  {/* Image Column */}
  <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
    <div className="card facility-card shadow">
      <img
        src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
        className="card-img-top facility-img"
        alt="University Library"
      />
    </div>
  </div>

  {/* Text Column */}
  <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.7s">
    <p className="mb-4">
      How to study English, in fact to learn any language 70% of your efforts
      should be in practicing and remaining 30% of efforts will be in theory.
      You have to spend more and more time in speaking English with your friends
      and classmates, watching English movies and channels. The most important
      factor is the surrounding environment—it must be helpful; otherwise, any
      effort and money you spend will go to waste. The people, students,
      classmates, teachers, and even markets you interact with should encourage
      English communication for best results.
    </p>
  </div>

</div>
                <div className="row align-items-start">
    
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">
We can introduce to you India as English medium country where you can achieve your target by very low cost with very high quality in teaching , we have British teachers which they are certified from Cambridge university and authorized from British council , they are very high qualified teachers and experts , in addition to that we have very high qualified Indian teachers and experts and they are also certified from Cambridge university and they have very sweet english accent .
</p>  </div>

    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library"/>
        </div>
    </div>
   

    
</div>
</div>
        </div>
    </div>
</div>

            
            <div className="highlight-box text-center mt-4 wow fadeInUp" data-wow-delay="0.3s">
                <h3 className="text-white mb-3">Save 70-80% on Education Costs</h3>
                {/* <p className="mb-0">Study in India and get world-class education at a fraction of Western costs</p> */}
            </div>
        </div>
    </div>
        </>
    )
}
export default Howcanispeak;